module.exports = __webpack_public_path__ + "img/Slider_Feria_del_Trabajo_2022.1b018b48.png";